import React from 'react';
import { CreditCardIcon, LockKeyholeIcon, ShieldCheckIcon, ZapIcon } from 'lucide-react';
import { CTAButton, PRICE, PRICE_FULL, SUPPORT_EMAIL, Section, WHATSAPP_LABEL, WHATSAPP_URL } from './Shared';
import { KanjiBackdrop, Mandala, Seal } from './Ornaments';
export function EmotionalClose() {
  return <Section className="max-w-4xl" data-id="element-18" data-mp="qmi3r84rcwty">
      <div className="paper-card relative overflow-hidden rounded-sm border border-brand-gold/55 p-7 text-center shadow-[0_18px_48px_rgba(44,38,32,0.13)] md:p-12" data-id="element-19" data-mp="qlfet5qzx4go">
        <KanjiBackdrop glyphs={['選', '擇', '今', '始', '道']} data-id="element-20" data-mp="hl0izcgeo6yx" />
        <Mandala className="absolute -right-20 -top-20 h-64 w-64 opacity-10" color="#A98546" data-id="element-21" data-mp="cmz12uupudp1" />
        <Mandala className="absolute -bottom-24 -left-24 h-64 w-64 opacity-10" color="#4A6B57" data-id="element-22" data-mp="7pgx7ivk2onw" />
        <div className="relative" data-id="element-23" data-mp="270qgkazq7rse">
          <h2 className="font-display text-3xl font-bold text-brand-ink md:text-5xl" data-id="element-24" data-mp="222omyw4oca2o">
            Hay dos versiones de ti en este momento.
          </h2>
          <div className="mx-auto mt-8 max-w-2xl space-y-5 text-base leading-relaxed text-brand-text md:text-lg" data-id="element-25" data-mp="350y174n9ymxu">
            <p data-id="element-26" data-mp="39zizgyiyuwjn">
              Una que cierra esta página y en la próxima sesión sigue
              dependiendo únicamente de su memoria. Sin un atlas visual que
              respalde cada punto. Sin protocolos clínicos organizados por
              patología. Sin el material técnico que sus pacientes merecen ver
              mientras están en la camilla.
            </p>
            <p className="font-semibold text-brand-forest" data-id="element-27" data-mp="3sqse1m7lgbi3">
              Y otra que decide que hoy es el día en que su práctica de
              acupuntura cambia para siempre.
            </p>
            <p className="font-display text-xl italic text-brand-goldDark" data-id="element-28" data-mp="3j0za97dp10oe">
              La pregunta no es si puedes pagarlo.
              <br data-id="element-29" data-mp="akdxrglurpgj" />
              La pregunta es cuántas sesiones más vas a trabajar sin el sistema
              visual que tu práctica y tus pacientes necesitan.
            </p>
          </div>
          <div className="mx-auto mt-12 max-w-md rounded-sm border-2 border-brand-cinnabar bg-brand-paper p-6 shadow-lg" data-id="element-30" data-mp="p8e8g3bvqco2">
            <span className="-mt-10 inline-block rounded-sm bg-brand-cinnabar px-3 py-1 text-[10px] font-bold uppercase tracking-[0.14em] text-brand-paper" data-id="element-31" data-mp="g8hhtw5xj3qd">
              ✦ Más elegido
            </span>
            <h3 className="mt-4 font-serif text-lg font-bold text-brand-ink md:text-xl" data-id="element-32" data-mp="6abgpgry61mk">
              ATLAS ANCESTRAL DE ACUPUNTURA™
            </h3>
            <p className="mt-3 text-sm text-brand-muted line-through" data-id="element-33" data-mp="1ithoy9hib48">
              {PRICE_FULL}
            </p>
            <p className="font-serif text-4xl font-bold text-brand-cinnabar" data-id="element-34" data-mp="3sq5w55izgagg">
              {PRICE}
            </p>
            <p className="mt-4 text-sm leading-relaxed text-brand-muted" data-id="element-35" data-mp="3omhoyny9jgvq">
              3 Tomos + 6 Bonos · 118 páginas + material completo. El sistema
              visual de acupuntura clínica más completo en español para
              terapeutas que quieren aplicar con precisión, velocidad y
              autoridad profesional.
            </p>
            <CTAButton fullWidth className="mt-6 py-3.5 text-sm" data-id="element-36" data-mp="1z64aegy8utp4">
              → QUIERO MI ATLAS ANCESTRAL {PRICE}
            </CTAButton>
          </div>
          <div className="mt-8 flex flex-wrap justify-center gap-x-4 gap-y-2 text-xs text-brand-muted md:text-sm" data-id="element-37" data-mp="244fmkyc0hgai">
            <span className="inline-flex items-center gap-1" data-id="element-38" data-mp="1bhuvlyzg767h">
              <LockKeyholeIcon className="h-4 w-4" data-id="element-39" data-mp="1bjflvceqc2zj" />
              Pago 100% seguro
            </span>
            <span className="inline-flex items-center gap-1" data-id="element-40" data-mp="1gel8kdfyhloo">
              <ZapIcon className="h-4 w-4" data-id="element-41" data-mp="1kh84apfqzqr5" />
              Acceso en 5 minutos
            </span>
            <span className="inline-flex items-center gap-1" data-id="element-42" data-mp="1pa191db7uz38">
              <ShieldCheckIcon className="h-4 w-4" data-id="element-43" data-mp="sr3c44lqxzfd" />
              Garantía 7 días
            </span>
            <span className="inline-flex items-center gap-1" data-id="element-44" data-mp="wsoto39871vw">
              <CreditCardIcon className="h-4 w-4" data-id="element-45" data-mp="wqvpqvpzyvrl" />
              Tarjeta o Mercado Pago
            </span>
          </div>
          <div className="mt-8 flex flex-col items-start gap-4 rounded-sm border border-brand-gold/40 bg-brand-surfaceLight/55 p-5 text-left text-sm leading-relaxed text-brand-text sm:flex-row" data-id="element-46" data-mp="dlqsqyrtuy6o">
            <Seal characters="附記" className="mt-0.5 text-[11px]" data-id="element-47" data-mp="nfpv9yvtcjz5" />
            <div className="min-w-0 flex-1" data-id="element-48" data-mp="illmda2zm1vf">
              <p className="break-words" data-id="element-49" data-mp="wel3fgif4453">
                <strong className="text-brand-ink" data-id="element-50" data-mp="wd9w56prke98">P.D.:</strong> Si tienes
                dudas, escríbenos a{' '}
                <a className="font-semibold text-brand-forest underline-offset-2 hover:underline" href={`mailto:${SUPPORT_EMAIL}`} data-id="element-51" data-mp="reyql86i4pwt">
                  {SUPPORT_EMAIL}
                </a>
                , a{' '}
                <a className="font-semibold text-brand-forest underline-offset-2 hover:underline" href="https://instagram.com/lumen.akasha" data-id="element-52" data-mp="383c96wttss8c">
                  @lumen.akasha
                </a>{' '}
                en Instagram o por WhatsApp al{' '}
                <a className="font-semibold text-brand-forest underline-offset-2 hover:underline" href={WHATSAPP_URL} data-id="element-53" data-mp="1nmcvr9lc6k0e">
                  {WHATSAPP_LABEL}
                </a>
                . Te respondemos hoy.
              </p>
              <p className="mt-3 italic text-brand-goldDark" data-id="element-54" data-mp="zvzaq3165lfb">
                El precio de lanzamiento sube pronto. El mejor momento para
                tener tu sistema visual de acupuntura clínica es ahora.
              </p>
            </div>
          </div>
        </div>
      </div>
    </Section>;
}